import { Link } from 'react-router-dom';
import { usePortal } from '../../app/AuthProvider';
import { roleLabel, visibleModules } from '../../app/modules';
import { homePathFor } from '../../app/routes';
import { useIsPhone } from '../../app/useIsPhone';
import { Chip, EmptyState } from '../../ui/components';
import { useLatestUpload } from '../../features/analytics/useAnalytics';
import { freshness } from '../../features/analytics/freshness';

/** The home screen (D83): one tile per module the person can open. */
export function PortalHome() {
  const { access, portalAdmin, role, org } = usePortal();
  const phone = useIsPhone();
  const tiles = visibleModules(access, portalAdmin);
  const upload = useLatestUpload(org.id, tiles.some((m) => m.key === 'analytics' && m.enabled));
  const fresh = upload.data ? freshness(upload.data) : null;

  if (tiles.length === 0) {
    return <EmptyState title="No modules yet">An administrator can grant access under People.</EmptyState>;
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {tiles.map((m) => {
        const Icon = m.icon;
        const myRole = portalAdmin ? 'admin' : access[m.key];
        const to = m.key === 'scheduler' && role ? homePathFor(role, phone) : m.path;
        const body = (
          <>
            <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${m.enabled ? 'bg-navy text-white' : 'bg-band text-ink-muted'}`}>
              <Icon size={24} />
            </span>
            <span className="mt-4 block text-lg font-semibold text-navy">{m.label}</span>
            <span className="mt-1 flex items-center gap-2 text-xs text-ink-muted">
              {m.enabled ? roleLabel(m.key, myRole) : <Chip tone="neutral">Coming soon</Chip>}
            </span>
            {m.key === 'analytics' && fresh && <span className={`mt-1 block text-xs ${fresh.stale ? 'font-medium text-warn' : 'text-ink-muted'}`}>{fresh.text}</span>}
          </>
        );
        const cls = 'block rounded-xl border bg-white p-6 text-left shadow-sm transition-shadow';
        return m.enabled ? (
          <Link key={m.key} to={to} className={`${cls} border-line hover:border-gold hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-gold`}>
            {body}
          </Link>
        ) : (
          <div key={m.key} className={`${cls} border-dashed border-line opacity-70`} aria-disabled>
            {body}
          </div>
        );
      })}
    </div>
  );
}
